import { isMobile, strNormalize } from '../../store/utils/general'

import store from '@/store';

/**
 * Check if current user has some module
 *
 * @param {String} module module name to check
 * @returns {Boolean}
 */
export function hasModule(module) {
  let modules = [];
  // console.log('store.state.auth.params.User.modules',store.state.auth.params.User.modules)

  try {
    modules = store.state.auth.params.User.modules
    if (typeof modules == "string") {
      let _modules = []
      _modules[modules] = modules
      modules = _modules
    }
    modules = Object.keys(modules)
  } catch (error) {
    console.warn('nenhum módulo encontrado')
  }
  return modules.indexOf(module) >= 0
}

/**
 *
 * Converts the Object agentsPlace data from current user into agentCard/agentForm data
 *
 * @param {Object} agentData dados do agente que será formatado
 * @param {Number} currentPlaceId ID do estabelecimeto do usuário logado
 * @param {Array} placeAgentXFields conjunto de campos AgentXFields do usuário logado
 * @param {Object} dinamicOptions Lista de opções para campos dinânmicos. {field_label:{...options}}
 * @param {Object} requiredFields Lista de campos obrigatórios para a entidade. {field_label:{label:'a',public_label:'b',type:'text'}}
 *
 * @returns {Object} dados do agente formatado
 */
export function formatAgentData(agentData, currentPlaceId, placeAgentXFields, dinamicOptions, requiredFields) {
  let formatedAgentData = {}
  let defaultChangedXfield = {
    type: 'hidden_config',
    options: { "": "" },
    label: 'changed',
    public_label: 'Última alteração',
    value: JSON.stringify((new Date()).toISOString())
  }
  let defaultAgentsPlace = { xfields: JSON.stringify({ changed: defaultChangedXfield }) }
  let public_access = false
  //Current Agent Data
  formatedAgentData.agent = agentData.Agent
  formatedAgentData.city = agentData.City
  formatedAgentData.agentsPlace = agentData.AgentsPlace
  formatedAgentData.formations = agentData.AgentsFormations
  agentData.Place.xfields = agentData.Place.xfields ? JSON.parse(agentData.Place.xfields) : {}
  formatedAgentData.place = agentData.Place

  if (!currentPlaceId) {
    public_access = true
    currentPlaceId = formatedAgentData.agent.place_id || 0
  }
  if (undefined == placeAgentXFields) {
    placeAgentXFields = {}
  }
  if (undefined == requiredFields) {
    requiredFields = {}
  }

  //searching current logged user metadata object
  let currentUserAgentsPlace = formatedAgentData.agentsPlace.find(agentPlace => agentPlace.place_id == currentPlaceId)

  //if no metadata data is founded use first metadata registred (id=0) or use empty metadata object
  if (undefined == currentUserAgentsPlace) {
    currentUserAgentsPlace = formatedAgentData.agentsPlace[0] ? formatedAgentData.agentsPlace[0] : defaultAgentsPlace
  }

  formatedAgentData.mainPlaceAgentData = JSON.parse(currentUserAgentsPlace.xfields)

  //the founded metada is from another place
  if (!public_access && currentUserAgentsPlace.place_id != currentPlaceId) {
    delete formatedAgentData.mainPlaceAgentData.active
  }

  //compatibilize to old "Ativo" xfield to "active"
  if (formatedAgentData.mainPlaceAgentData.active == undefined) {
    formatedAgentData.mainPlaceAgentData = compatibilizeActiveXField(formatedAgentData.mainPlaceAgentData)
  }

  //compatibilize to old "Última alteração" xfield to "changed"
  if (formatedAgentData.mainPlaceAgentData.changed == undefined) {
    formatedAgentData.mainPlaceAgentData.changed = defaultChangedXfield
    formatedAgentData.mainPlaceAgentData.changed.value = currentUserAgentsPlace.changed
  }
  if (placeAgentXFields['changed'] == undefined) {
    placeAgentXFields['changed'] = defaultChangedXfield
  }

  //check the metadata has all required fileds
  Object.keys(requiredFields).map((requiredFieldLabel) => {
    let requiredField = placeAgentXFields[requiredFieldLabel]
    //TODO: if disabled fields will be handled as removed field....
    if (requiredField && requiredField.type == 'disabled') {
      requiredField = undefined
    }

    if (undefined == requiredField) {
      if (undefined != formatedAgentData.mainPlaceAgentData[requiredFieldLabel]) {
        placeAgentXFields[requiredFieldLabel] = formatedAgentData.mainPlaceAgentData[requiredFieldLabel]
        delete placeAgentXFields[requiredFields[requiredFieldLabel]['public_label']]
      } else {
        placeAgentXFields[requiredFieldLabel] = { label: requiredFieldLabel, value: "" }
      }
      if (undefined == placeAgentXFields[requiredFieldLabel]['public_label']) {
        placeAgentXFields[requiredFieldLabel] = requiredFields[requiredFieldLabel]
      }
      if (undefined == placeAgentXFields[requiredFieldLabel]['options']) {
        placeAgentXFields[requiredFieldLabel]['options'] = (placeAgentXFields[requiredFieldLabel] && placeAgentXFields[requiredFieldLabel].options) ? placeAgentXFields[requiredFieldLabel].options : { "": "" }
      }
    }
  })

  let _mainPlaceAgentData = {}
  let xfield = {}
  if (Object.keys(placeAgentXFields).length > 1) {
    Object.keys(placeAgentXFields).map((label) => {
      xfield = JSON.parse(JSON.stringify(placeAgentXFields[label]))
      //merging agent metadata to current version edition mode
      if (formatedAgentData.mainPlaceAgentData[label] == undefined) {
        if (formatedAgentData.mainPlaceAgentData[xfield.public_label] != undefined) {
          //change old label and set public_label
          formatedAgentData.mainPlaceAgentData[label] = formatedAgentData.mainPlaceAgentData[xfield.public_label]
          delete formatedAgentData.mainPlaceAgentData[xfield.public_label]
        } else {
          formatedAgentData.mainPlaceAgentData[label] = { type: xfield.type, value: '' }
        }
      }
      if (undefined == formatedAgentData.mainPlaceAgentData[label].value) {
        //define "value" metadata property
        if (formatedAgentData.mainPlaceAgentData[label].label != label) {
          formatedAgentData.mainPlaceAgentData[label].value = formatedAgentData.mainPlaceAgentData[label].label
        } else {
          formatedAgentData.mainPlaceAgentData[label].value = ''

        }
        formatedAgentData.mainPlaceAgentData[label].label = label
      }
      formatedAgentData.mainPlaceAgentData[label].label = xfield.label
      formatedAgentData.mainPlaceAgentData[label].public_label = xfield.public_label
      formatedAgentData.mainPlaceAgentData[label].options = xfield.options
      formatedAgentData.mainPlaceAgentData[label].type = xfield.type
      formatedAgentData.mainPlaceAgentData[label] = handleDinamicOptions(formatedAgentData.mainPlaceAgentData[label], dinamicOptions)
      _mainPlaceAgentData[label] = formatedAgentData.mainPlaceAgentData[label]
      if (Object.keys(requiredFields).indexOf(label) >= 0) {
        delete requiredFields[label]
      }
    })
    //get formation files and validate
    Object.keys(formatedAgentData.mainPlaceAgentData).map(label => {
      if(label.startsWith('formationfile_') || label.startsWith('formationvalid_'))
      _mainPlaceAgentData[label] = formatedAgentData.mainPlaceAgentData[label]

    })
    formatedAgentData.mainPlaceAgentData = _mainPlaceAgentData
  }

  //Whatsapp link
  if (formatedAgentData.mainPlaceAgentData.mobile != undefined) {
    if (formatedAgentData.mainPlaceAgentData.mobile.value) {
      formatedAgentData.mainPlaceAgentData.mobile.whatsapp = handlePhone(formatedAgentData.mainPlaceAgentData.mobile.value)
    }
  }

  Object.keys(formatedAgentData.mainPlaceAgentData).map((label) => {
    let field = formatedAgentData.mainPlaceAgentData[label]
    field = convertMetaType(formatedAgentData.mainPlaceAgentData[label], placeAgentXFields[field.label])
    if (undefined == field.value) {
      field.value = field.label
    }
    field.label = label
    if (undefined == placeAgentXFields[label]) {
      field.type = 'disabled'
    }
    formatedAgentData.mainPlaceAgentData[label] = field
    if (undefined != field.cumulative && field.cumulative == true) {
      field.value = []
      let valueIds = []
      formatedAgentData.agentsPlace.forEach(agentPlace => {
        let xfields = JSON.parse(agentPlace.xfields)
        if (undefined != xfields[field.label] && Object.prototype.toString.call(xfields[field.label]['value']) == '[object Array]') {
          xfields[field.label].value.forEach((vItem) => {
            if (valueIds.indexOf(vItem.id) == -1) {
              valueIds.push(vItem.id)
              field.value.push(vItem)
            }
          })
        }
      })
    }
  })

  return formatedAgentData
}

/**
 * configura o typo de input de acordo com os metatipos do bocapio
 *
 * @param {Object} field objeto metatipo definidos no Bocapio Xfields
 * @returns objeto field com a prorpety type HTML padrão
 */
function convertMetaType(field, placeAgentXField) {
  switch (field.type) {
    case 'file-image':
      field.type = 'file'
      break
    case 'textarea-tinymce':
      field.type = 'textarea'
      break
    case 'mail':
      field.type = 'email'
      break
    case 'checkboxmultiple':
      // field.type = 'checkbox'
      field.multiple = true
      break
    case 'phone':
      field.type = 'tel'
      break
    case 'cpf':
      field.type = 'text'
      break
    case 'cnpj':
      field.type = 'text'
      break
    case 'site':
      field.type = 'text'
      break
    case 'select':
      if (field.value == '' || field.value == '--') {
        field.value = ''
      }
      if (field.options && typeof field.options == 'object') {
        field.options = Object.values(field.options).map((option) => {
          if (typeof option == 'string' && option != '{"": ""}') {
            option = option.split(':')
            if (undefined != option[1]) {
              return { id: `_${option[0]}`, value: option[0], label: option[1] }
            } else {
              return { id: `_${option[0]}`, value: option[0], label: option[0] }
            }
          } else {
            option.id = `_${option.value}`
            return option
          }
        })
      }

      if (Object.prototype.toString.call(field.value) == '[object Array]') {
        field.multiple = true

      } else {
        field.multiple = false

      }
      break
    case 'selectmultiple':
      if (field.value == '') {
        field.value = []
      }
      if (field.value && typeof field.value == 'object') {
        field.value = Object.values(field.value).map((v) => {
          if (undefined == v.id) {
            v.id = `_${v.value}`
          }
          return v
        })
      }


      if (field.options && typeof field.options == 'object') {
        field.options = Object.values(field.options).map((option, idx) => {
          if (typeof option == 'string') {
            option = option.split(':')
            if (undefined != option[1]) {
              return { id: `_${option[0]}`, value: option[0], label: option[1] }
            } else {
              let id = option[0]
              id = id.split(' ')[0]
              id = strNormalize(id, true, ' ')

              return { id: `_${id}`, value: option[0], label: option[0] }
            }
          } else {
            option.id = `_${idx}`
            return option
          }
        })
      }
      field.type = 'select'
      field.multiple = true

      break

    case 'date':
      if (field.value != '' && field.value.indexOf('/') > 0) {
        field.value = field.value.split('/').reverse().join('-')
      }
      break

    case 'number-positive':
      try {
        field.min = undefined != field.options.min ? field.options.min : '0'
      } catch (error) {
        field.min = ''
      }
      field.type = 'number'
      break
    case 'disabled':
      break
    case 'hidden_config':
      break
    default:
      // console.log('default type',field.type)
      break
  }
  return field
}

/**
 * compatibilize the old "Ativo" xfields to new "active"
 * @param {Object} data
 * @returns active xfield object
*/
function compatibilizeActiveXField(xfieldsData) {
  //compatibilize to old xfields map version
  if (xfieldsData.active == undefined) {
    if (xfieldsData.Ativo != undefined) {
      xfieldsData.active = xfieldsData.Ativo
      delete xfieldsData.Ativo
    } else {
      xfieldsData.active = { public_label: 'Ativo', label: 'active', value: 'false', type: 'checkbox' }
    }
  }

  if (undefined == xfieldsData.active.value) {
    xfieldsData.active = { public_label: 'Ativo', value: xfieldsData.active.label, label: 'active', type: 'checkbox' }
  }
  if (undefined != xfieldsData.active.value) {
    xfieldsData.active.value = xfieldsData.active.value === '1' || xfieldsData.active.value === 'true' ? 'true' : 'false'
  } else {
    xfieldsData.active = xfieldsData.active === '1' || xfieldsData.active === 'true' ? { value: 'true', label: 'active', type: 'checkbox' } : { value: 'false', label: 'active', type: 'checkbox' }
  }
  return xfieldsData
}

export function handlePhone(phone, returnType) {
  phone = phone.replace(/\D/g, "")
  if (phone.length == 8) {
    phone = `9${phone}`
  }
  if (phone.length == 9) {
    phone = `77${phone}`
  }
  if (phone.length == 11) {
    phone = `+55${phone}`
  }

  switch (returnType) {
    case "number":
      return phone
      break;

    default:
      return `${isMobile() ? 'whatsapp://' : 'https://web.whatsapp.com/'}send?phone=${phone}`
      break;
  }
}

function handleDinamicOptions(field, dinamicValues) {
  let loadDataValue = false
  let loadDataCumulative = false
  let _options = []
  if (Object.keys(field.options).indexOf('dinamiclabel') >= 0) {
    loadDataValue = field.options['dinamiclabel'].split(':')[1]
  }
  if (Object.keys(field.options).indexOf('cumulative') >= 0) {
    loadDataCumulative = field.options['cumulative'].split(':')[1]
    if (loadDataCumulative) {
      field.cumulative = true
    }
  }
  if (dinamicValues[loadDataValue]) {
    dinamicValues[loadDataValue].forEach(element => {
      _options.push({ value: element.id, label: element.name })
      // _options.push({ value: element.id + 1, label: element.name + ' 1' })
      // _options.push({ value: element.id + 2, label: element.name + ' 2' })
      // _options.push({ value: element.id + 3, label: element.name + ' 3' })
      // _options.push({ value: element.id + 4, label: element.name + ' 4' })
      // _options.push({ value: element.id + 5, label: element.name + ' 5' })
      // _options.push({ value: element.id + 6, label: element.name + ' 6' })
      // _options.push({ value: element.id + 7, label: element.name + ' 7' })
      // _options.push({ value: element.id + 8, label: element.name + ' 8' })
      // _options.push({ value: element.id + 9, label: element.name + ' 9' })
      // _options.push({ value: element.id + 10, label: element.name + ' 10' })
      // _options.push({ value: element.id + 11, label: element.name + ' 11' })
    });
    field.options = _options
  }

  return field
}
